module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('sidebar', {
    ref: "sidebar"
  }, [_c('div', {
    staticClass: "centertext"
  }, [_c('i', {
    staticClass: "unhide huge icon"
  }), _vm._v(" "), _c('div', [_vm._v("Hi, " + _vm._s(_vm.$getUser().name))])]), _vm._v(" "), _c('div', {
    staticClass: "ui inverted divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui vertical inverted menu"
  }, _vm._l((_vm.menuItems), function(item) {
    return _c('a', {
      staticClass: "item",
      attrs: {
        "name": item.name
      },
      on: {
        "click": function($event) {
          _vm.$router.push(item.link)
        }
      }
    }, [_c('i', {
      staticClass: "icon",
      class: [item.icon]
    }), _vm._v(" " + _vm._s(item.label) + "\n      ")])
  }))]), _vm._v(" "), (['home', 'login', 'signup', 'thankyou'].indexOf(this.$router.currentRoute.name) === -1) ? _c('section', {
    staticClass: "ui equal width padded grid",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "row ui segment toolbar"
  }, [_c('div', {
    staticClass: "column",
    staticStyle: {
      "padding-right": "0"
    }
  }, [_c('a', {
    staticStyle: {
      "margin-left": ".1em"
    },
    on: {
      "click": function($event) {
        _vm.onHome()
      }
    }
  }, [_c('i', {
    staticClass: "unhide big icon green"
  }), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "right aligned column",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(!_vm.$isTokenExpired()) ? _c('div', [_c('div', {
    staticClass: "ui labeled tiny button",
    attrs: {
      "tabindex": "0"
    }
  }, [_c('div', {
    staticClass: "ui grey tiny button",
    attrs: {
      "data-tooltip": "Actions List",
      "data-inverted": "",
      "data-position": "left center"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onMenu($event)
      }
    }
  }, [_c('i', {
    staticClass: "windows icon"
  })]), _vm._v(" "), _c('a', {
    staticClass: "ui grey basic label",
    attrs: {
      "data-tooltip": "Sign Out",
      "data-inverted": "",
      "data-position": "left center"
    },
    on: {
      "click": _vm.onSignout
    }
  }, [_c('i', {
    staticClass: "sign small out icon",
    staticStyle: {
      "font-size": "1.2em"
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.$isTokenExpired()) ? _c('div', [_c('span', {
    staticStyle: {
      "letter-spacing": ".07em",
      "color": "#767676"
    }
  }, [_vm._v("Already a customer?")]), _vm._v(" "), _c('button', {
    staticClass: "ui grey tiny button",
    attrs: {
      "data-tooltip": "Login to your account",
      "data-inverted": "",
      "data-position": "top right"
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/login')
      }
    }
  }, [_vm._v("LOG IN")])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('section', {
    attrs: {
      "id": "contents"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('constatus'), _vm._v(" "), _c('onerror')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_vm._v("Restock"), _c('i', {
    staticClass: "registered icon"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4aab8dae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 445
// module chunks = 28